import React from "react";
import { useTranslation } from "react-i18next";
import { CancelCrossIcon, Title1, Body2, IconButton } from "@activecollab/components";
import classnames from "classnames";
import classNames from "classnames";
import PropTypes from "prop-types";
import { TrophyIcon } from "~/components/svg";
import styles from "./MyTasksDelighter.module.css";

export const MyTasksDelighter = ({ className, onDismiss }) => {
  const { t } = useTranslation();

  return (
    <div
      className={classnames(
        "tw-flex tw-items-center tw-relative tw-flex-col tw-p-8 lg:tw-flex-row lg:tw-p-0",
        className,
        styles.minHeight
      )}
    >
      <IconButton
        className={classNames("tw-absolute", styles.topRight4)}
        size="small"
        variant="text gray"
        onClick={onDismiss}
      >
        <CancelCrossIcon />
      </IconButton>
      <div className="tw-mx-16 tw-flex tw-items-center tw-justify-center">
        <TrophyIcon
          width={80}
          height={100}
          className="tw-max-w-md tw-fill-theme-900"
        />
      </div>
      <div>
        <Title1
          weight="bold"
          className="tw-my-4 tw-leading-none tw-text-2xl md:tw-text-3xl tw-text-center md:tw-text-left"
        >{`${t("You completed all your tasks")}.`}</Title1>
        <Body2
          color="tertiary"
          className="tw-my-4 tw-text-center md:tw-text-left"
        >{`${t("Take a deep breath and refresh until the next assignment")}.`}</Body2>
      </div>
    </div>
  );
};

MyTasksDelighter.propTypes = {
  className: PropTypes.string,
  onDismiss: PropTypes.func,
};
